import './style.css';

import { markStartup, waitForInitialPaint } from './performance/startup';

markStartup('loader-visible');

function showBootstrapFailure(error: unknown): void {
  const loader = document.querySelector<HTMLElement>('#startup-loader');
  const message = document.querySelector<HTMLElement>('#startup-loader-message');
  const retry = document.querySelector<HTMLButtonElement>('#startup-retry');
  if (message !== null) {
    message.textContent =
      error instanceof Error
        ? `No pudimos iniciar el atlas: ${error.message}`
        : 'No pudimos iniciar el atlas.';
  }
  loader?.setAttribute('aria-busy', 'false');
  if (loader !== null) loader.dataset['state'] = 'error';
  if (retry !== null) {
    retry.hidden = false;
    retry.addEventListener('click', () => window.location.reload(), { once: true });
  }
}

async function start(): Promise<void> {
  await waitForInitialPaint();
  markStartup('bootstrap-requested');
  const { startQuillay } = await import('./bootstrap');
  await startQuillay();
}

void start().catch(showBootstrapFailure);
